import { render } from "./LinkageFooter.vue?vue&type=template&id=770d44e4&ts=true"
import script from "./LinkageFooter.vue?vue&type=script&lang=ts"
export * from "./LinkageFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__